import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaExclamationTriangle,
  FaHome,
  FaRedo,
} from "react-icons/fa";

import backgroundImage from "./bouscat02.webp";

function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const error = params.get("error") || "Une erreur inconnue est survenue.";

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate("/");
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-900 dark:text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      <div className="absolute inset-0 bg-slate-950/75" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(239,68,68,0.22),transparent_35%),radial-gradient(circle_at_80%_35%,rgba(59,130,246,0.22),transparent_40%)]" />

      <main className="relative z-10 flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-xl overflow-hidden rounded-[2rem] border border-white/10 bg-white/95 p-6 text-center shadow-2xl backdrop-blur-xl dark:bg-slate-900/95 sm:p-8">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-[1.75rem] bg-red-500/10 text-red-500">
            <FaExclamationTriangle size={34} />
          </div>

          <p className="mt-6 text-sm font-bold uppercase tracking-[0.25em] text-red-500">
            Une erreur est survenue
          </p>

          <h1 className="mt-3 text-3xl font-bold text-slate-950 dark:text-white sm:text-4xl">
            Oups, impossible de continuer
          </h1>

          <div className="mt-6 rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-medium leading-7 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300">
            {error}
          </div>

          <div className="mt-8 grid gap-3 sm:grid-cols-3">
            <button
              type="button"
              onClick={handleGoBack}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-primary px-5 py-3 text-sm font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl"
            >
              <FaArrowLeft />
              Retour
            </button>

            <button
              type="button"
              onClick={() => navigate("/")}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:text-primary hover:shadow-lg dark:border-white/10 dark:bg-slate-950 dark:text-white"
            >
              <FaHome />
              Accueil
            </button>

            <button
              type="button"
              onClick={handleReload}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:text-primary hover:shadow-lg dark:border-white/10 dark:bg-slate-950 dark:text-white"
            >
              <FaRedo />
              Réessayer
            </button>
          </div>

          <p className="mt-7 text-xs leading-6 text-slate-500 dark:text-slate-300">
            Si le problème persiste, contactez l’administrateur du site avec le
            message d’erreur affiché ci-dessus.
          </p>
        </div>
      </main>
    </div>
  );
}

export default ErrorPage;